<template>
  <div class="model-count">
    <Chart
      v-if="!isFirstLoad && !isError && !isNoData"
      :options="chartOptions"
    />
    <div v-else-if="isFirstLoad" class="sk-three-bounce">
      <div class="sk-child sk-bounce1"></div>
      <div class="sk-child sk-bounce2"></div>
      <div class="sk-child sk-bounce3"></div>
    </div>
    <NoData v-else-if="isNoData"/>
    <ChartError v-else class="error-container"></ChartError>
  </div>
</template>

<script>
  import {mapActions, mapGetters, mapState} from "vuex";
  import {Chart} from "highcharts-vue";
  import {HIGHCHARTS_DEFAULTS} from "../../constants";
  import ChartError from "../errors/ChartError";
  import NoData from "../errors/NoData";

  export default {
    name: "BandwidthUsage",
    components: {
      Chart,
      ChartError,
      NoData
    },
    props: ['sitecode','dateRange', 'searchInput'],
    mounted() {
      if (this.sitecode) {
        this.fetchBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      }
    },
    computed: {
      ...mapState({
        bandwidthUsage: s => s.api.chartData.bandwidthUsage
      }),
      ...mapGetters(['bandwidthUsageSeries']),
      isError () {
        return this.bandwidthUsage.error;
      },
      isNoData () {
        const data = this.bandwidthUsageSeries;
        return !(Array.isArray(data) && data.length > 0);
      },
      isFirstLoad() {
        return this.bandwidthUsage.loading && this.bandwidthUsage.lastUpdatedAt == null;
      },
      chartOptions: function () {
        return Object.assign({}, HIGHCHARTS_DEFAULTS, {
          // colors: [
          //   "#1d428a",
          //   "#2c5697",
          //   "#407ec9",
          //   "#6cace4",
          //   "#a4c8e1",
          //   "#c6dae7"
          // ],
          chart: {
            type: "bar",
          },
          exporting: {
            enabled: false
          },
          title: {
            // text: "<span style=\"font-size: larger; font-weight: bold\">Bandwidth usage (Mbps)</span>"
            text: ""
          },
          xAxis: {
            type: "category",
            // min: 0,
            // max: 9,
            scrollbar: {
              enabled: true
            },
          },
          yAxis: {
            title: {
              text: ""
            },
          },
          legend: {
            enabled: false
          },
          series: [
            {
              name: "Bandwidth usage (Mbps)",
              data: this.bandwidthUsageSeries,
              maxPointHeight: 50
            }
          ],
          plotOptions: {
            bar: {}
          },
          drilldown: {
            activeAxisLabelStyle: {
              textDecoration: 'none',
              color: 'rgba(0,0,0,.8)'
            },
            drillUpButton: {
              relativeTo: "spacingBox",
              position: {
                y: -30,
                x: 0
              }
            }
          }
        });
      }
    },
    methods: {
      ...mapActions(['fetchBandwidthUsage'])
    },
    watch: {
      sitecode: function () {
        this.fetchBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      },
      dateRange: function () {
        this.fetchBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      },
      searchInput: function () {
        this.fetchBandwidthUsage({sitecode: this.sitecode, dateRange: this.dateRange, searchInput: this.searchInput});
      }
    }
  };
</script>
<style scoped>
</style>
